var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDateIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_122779",
    "data-name": "Group 122779",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_267",
    "data-name": "Ellipse 267",
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#1b4a83"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-date-range",
    "data-name": "Icon material-date-range",
    d: "M9.009,9.764h-1.5v1.5h1.5Zm3.006,0h-1.5v1.5h1.5Zm3.006,0h-1.5v1.5h1.5Zm1.5-5.261h-.752V3h-1.5V4.5H8.258V3h-1.5V4.5H6a1.5,1.5,0,0,0-1.5,1.5L4.5,16.527A1.5,1.5,0,0,0,6,18.03H16.524a1.507,1.507,0,0,0,1.5-1.5V6.006A1.507,1.507,0,0,0,16.524,4.5Zm0,12.024H6V8.261H16.524Z",
    transform: "translate(3.158 3.485)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/dateIcon.c5eb8ff442446ac47f2f365db8ba26d9.svg";
export { ForwardRef as ReactComponent };